module.exports = __webpack_public_path__ + "static/media/bunu_where_i_left.826d735a.png";